import { useState, useEffect, useContext } from "react";
import styles from "./barraSuperior.module.css";
import { Form, Col, Container, Row, Button, Image } from "react-bootstrap";
import skyLogo from "../assets/img/BarraSuperior/skyLogo.png";
import { BarraMenu } from "../BarraMenu/BarraMenu";
import { ProSidebarProvider } from "react-pro-sidebar";
import { GiHamburgerMenu } from "react-icons/gi";
import { CgClose } from "react-icons/cg";
import { Cuenta } from "../Commons/Services/ConsultarCuentaAsociada";
import ContextFlujos from "../Context/ContextFlujos";
import {
  ConsultaCuenta_Respuesta,
  ConsultaCuentaRest_Parametros,
  ConsultaCuentaRest_Entrada,
  builtConsultaCuentaRestInput,
} from "../Commons/Services/ConsultaCuentaRest";
import { ConsultaWS } from "../Commons/ServiciosBase";
import {
  ConsultarSaldosCorrientes_Respuesta,
  ConsultarSaldosCorrientes_Parametros,
  ConsultarSaldosCorrientes_Entrada,
  builtConsultarSaldosCorrientesInput,
} from "../Commons/Services/ConsultarSaldosCorrientesRest";
import {
  ConsultarServiciosCuenta_Respuesta,
  ConsultarServiciosCuenta_Parametros,
  builtInputVarConsultarServiciosCuentaInput,
  ConsultarServiciosCuenta_Entrada,
  ServicioEBO,
} from "../Commons/Services/ConsultarServiciosCuentaRest";
import {
  ConsultarIRD_Entrada,
  ConsultarIRD_Parametros,
  ConsultarIRD_Respuesta,
  Tarjeta,
} from "../Commons/Services/ConsultarIRD";

import {
  AccountDetails_Entrada,
  AccountDetails_Parametros,
  AccountDetails_Respuesta,
} from "../Commons/Services/AccountDetails";
import Loading from "../General/Loading";
import {
  ConsultarCuentaEspecial_Entrada,
  builtConsultarCuentaEspecial_Entrada,
  ConsultarCuentaEspecial_Parametros,
  ConsultarCuentaEspecial_Respuesta,
} from "../Commons/Services/ConsultarCuentaEspecial";
import {
  ConsultarTICorporativo_Respuesta,
  ConsultarTICorporativo_Parametros,
  ConsultarTICorporativo_Entrada,
  builtConsultarTICorporativo_Entrada,
} from "../Commons/Services/ConsultarTICorporativo";
import {
  ConsultaDatosGeneralesRest_Entrada,
  builtConsultaDatosGeneralesRest_Entrada,
  ConsultaDatosGeneralesRest_Parametros,
  ConsultaDatosGeneralesRest_Respuesta,
} from "../Commons/Services/ConsultaDatosGeneralesRest";
import {
  ConsultarCuentaAsociada_Entrada,
  builtConsultarCuentaAsociada_Entrada,
  ConsultarCuentaAsociada_Parametros,
  ConsultarCuentaAsociada_Respuesta,
} from "../Commons/Services/ConsultarCuentaAsociada";

export const BarraSuperior = () => {
  const flujo = sessionStorage.getItem("flujos");
  const { setSkyCelular, setSkyPlus, setTipoClienteContext, setPais } =
    useContext(ContextFlujos) as any;
  const [cuentasHijas, setCuentasHijas] = useState<Cuenta[]>([]);
  //const [cuentasHijaSeleccionada, setCuentasHijaSeleccionada] = useState("");
  const [showList, setshowList] = useState(false);
  const [banderaPais, setBanderaPais] = useState(false);

  const [loading, isLoading] = useState(false);

  const handleShow = () => {
    let menuLateral = document.getElementById("menuLateral");
    if (menuLateral !== null) {
      menuLateral.style.display = "flex";
    }

    const pageContent = document.getElementById("pageContent");
    if (pageContent !== null) {
      pageContent.style.display = "none";
    }

    const menuIcon = document.getElementById("menuIcon");
    if (menuIcon !== null) {
      menuIcon.style.display = "none";
    }

    const closeIcon = document.getElementById("closeIcon");
    if (closeIcon !== null) {
      closeIcon.style.display = "flex";
    }
  };

  const handleClose = () => {
    const menuLateral = document.getElementById("menuLateral");
    if (menuLateral !== null) {
      menuLateral.style.display = "none";
    }

    const pageContent = document.getElementById("pageContent");
    if (pageContent !== null) {
      pageContent.style.display = "block";
    }

    const menuIcon = document.getElementById("menuIcon");
    if (menuIcon !== null) {
      menuIcon.style.display = "flex";
    }

    const closeIcon = document.getElementById("closeIcon");
    if (closeIcon !== null) {
      closeIcon.style.display = "none";
    }
  };

  function doLogout() {
    //CODIGO PARA BORRAR DATOS DEL LOCAL STORAGE
    sessionStorage.setItem("authenticated", "false");
    //REDIRECT

    sessionStorage.clear();
    // dispatch("logout");
    redirect("/");
  }

  function redirect(url: string) {
    var ua = navigator.userAgent.toLowerCase(),
      isIE = ua.indexOf("msie") !== -1,
      version = parseInt(ua.substr(4, 2), 10);

    // Internet Explorer 8 and lower
    if (isIE && version < 9) {
      var link = document.createElement("a");
      link.href = url;
      document.body.appendChild(link);
      link.click();
    }

    // All other browsers can use the standard window.location.href (they don't lose HTTP_REFERER like Internet Explorer 8 & lower does)
    else {
      window.location.href = url;
    }
  }

  useEffect(() => {
    if (sessionStorage.getItem("esCuentaCorporativa") === "V") {
      let esCuentaCorporativaArray: Cuenta[] = JSON.parse(
        sessionStorage.getItem("esCuentaCorporativaArray")!
      );
      setCuentasHijas(esCuentaCorporativaArray);
      setshowList(true);
    }
  }, []);

  const obtieneCuentaHijaSeleccionada = async (e: any) => {
    isLoading(true);
    //setCuentasHijaSeleccionada(e.target.value);
    sessionStorage.setItem("cuenta", e.target.value);
    doConsultarCuentaEspecial(e.target.value);
  };

  const doConsultarCuentaEspecial = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------

      const ConsultarCuentaEspeciaEntrada: ConsultarCuentaEspecial_Entrada =
        builtConsultarCuentaEspecial_Entrada(p_numerocuenta);
      let ConsultarCuentaEspecialParametros =
        ConsultarCuentaEspecial_Parametros(ConsultarCuentaEspeciaEntrada);

      let ConsultarCuentaEspecialRespuesta: ConsultarCuentaEspecial_Respuesta =
        await ConsultaWS(ConsultarCuentaEspecialParametros);

      if (
        ConsultarCuentaEspecialRespuesta.CuentaSKY &&
        ConsultarCuentaEspecialRespuesta.CuentaSKYPadre &&
        ConsultarCuentaEspecialRespuesta.CuentaSKY != null &&
        ConsultarCuentaEspecialRespuesta.CuentaSKYPadre != null
      ) {
        sessionStorage.setItem(
          "esCuentaCorporativaInicial",
          ConsultarCuentaEspecialRespuesta.CuentaSKYPadre
        );
        if (
          ConsultarCuentaEspecialRespuesta.CuentaSKY ===
          ConsultarCuentaEspecialRespuesta.CuentaSKYPadre
        ) {
          sessionStorage.setItem("esCuentaCorporativaJerarquia", "false");
        } else {
          sessionStorage.setItem("esCuentaCorporativaJerarquia", "true");
        }

        doConsultarTICorporativo(
          sessionStorage.getItem("esCuentaCorporativaNombreCorporativo")!,
          p_numerocuenta
        );
      } else {
        console.error(ConsultarCuentaEspecialRespuesta);
        //doConsultarTICorporativo(sessionStorage.getItem("esCuentaCorporativaNombreCorporativo")!);
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      //doConsultarTICorporativo(sessionStorage.getItem("esCuentaCorporativaNombreCorporativo")!);
      isLoading(false);
    }
  };

  const doConsultarTICorporativo = async (
    p_NombreGrupo: string,
    p_numerocuenta: string
  ) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      var consultarTICorporativo_Entrada: ConsultarTICorporativo_Entrada =
        builtConsultarTICorporativo_Entrada(p_NombreGrupo);
      let ConsultarTICorporativoParametros = ConsultarTICorporativo_Parametros(
        consultarTICorporativo_Entrada
      );

      let ConsultarTICorporativoRespuesta: ConsultarTICorporativo_Respuesta =
        await ConsultaWS(ConsultarTICorporativoParametros);

      if (
        ConsultarTICorporativoRespuesta.resultado === "0" &&
        ConsultarTICorporativoRespuesta.resultadodesc === "0" &&
        ConsultarTICorporativoRespuesta.ListaTarjetasInteligentes &&
        ConsultarTICorporativoRespuesta.ListaTarjetasInteligentes != null &&
        ConsultarTICorporativoRespuesta.ListaTarjetasInteligentes.length > 0
      ) {
        sessionStorage.setItem(
          "esCuentaCorporativaTI",
          JSON.stringify(
            ConsultarTICorporativoRespuesta.ListaTarjetasInteligentes
          )
        );
        doConsultaDatosGeneralesRest(p_numerocuenta);
      } else {
        console.error("No hay Tarjetas inteligentes corporativas");
        sessionStorage.setItem("esCuentaCorporativaTI", JSON.stringify([]));
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      sessionStorage.setItem("esCuentaCorporativaTI", JSON.stringify([]));
      isLoading(false);
    }
  };

  const doConsultaDatosGeneralesRest = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaDatosGeneralesRestEntrada: ConsultaDatosGeneralesRest_Entrada =
        builtConsultaDatosGeneralesRest_Entrada(p_numerocuenta);
      let ConsultaDatosGeneralesRestParametros =
        ConsultaDatosGeneralesRest_Parametros(
          ConsultaDatosGeneralesRestEntrada
        );

      let ConsultaDatosGeneralesRestRespuesta: ConsultaDatosGeneralesRest_Respuesta =
        await ConsultaWS(ConsultaDatosGeneralesRestParametros);
      if (
        ConsultaDatosGeneralesRestRespuesta.respuesta &&
        ConsultaDatosGeneralesRestRespuesta.respuesta === "0"
      ) {
        let vNombreSuscriptor = "NA";

        if (
          ConsultaDatosGeneralesRestRespuesta.NombreSuscriptor != "" &&
          ConsultaDatosGeneralesRestRespuesta.NombreSuscriptor != null &&
          typeof ConsultaDatosGeneralesRestRespuesta.NombreSuscriptor !=
            "undefined"
        ) {
          vNombreSuscriptor =
            ConsultaDatosGeneralesRestRespuesta.NombreSuscriptor.toUpperCase();

          sessionStorage.setItem(
            "esCuentaCorporativaNombreSelected",
            vNombreSuscriptor
          );
        } else {
          if (
            sessionStorage.getItem("esCuentaCorporativaNombreSelected") != "" &&
            sessionStorage.getItem("esCuentaCorporativaNombreSelected") !=
              null &&
            typeof sessionStorage.getItem(
              "esCuentaCorporativaNombreSelected"
            ) != "undefined"
          ) {
            vNombreSuscriptor = sessionStorage.getItem(
              "esCuentaCorporativaNombreSelected"
            )!;
          } else {
            vNombreSuscriptor = sessionStorage.getItem(
              "esCuentaCorporativaNombreCompletoTMP"
            )!;
          }
        }

        sessionStorage.setItem("NombreSuscriptor", vNombreSuscriptor);
        sessionStorage.setItem("Nombre", obtenerSoloNombre(vNombreSuscriptor));
        sessionStorage.setItem(
          "APaterno",
          obtenerSoloApellidoPaterno(vNombreSuscriptor)
        );
        sessionStorage.setItem(
          "AMaterno",
          obtenerSoloApellidoMaterno(vNombreSuscriptor)
        );
        //isLoading(false);
        doConsultaCuenta(p_numerocuenta);
      } else {
        let vNombreSuscriptor = "NA";
        if (
          sessionStorage.getItem("esCuentaCorporativaNombreSelected") != "" &&
          sessionStorage.getItem("esCuentaCorporativaNombreSelected") != null &&
          typeof sessionStorage.getItem("esCuentaCorporativaNombreSelected") !=
            "undefined"
        ) {
          vNombreSuscriptor = sessionStorage.getItem(
            "esCuentaCorporativaNombreSelected"
          )!;
        } else {
          vNombreSuscriptor = sessionStorage.getItem(
            "esCuentaCorporativaNombreCompletoTMP"
          )!;
        }

        console.error(ConsultaDatosGeneralesRestRespuesta);
        sessionStorage.setItem("NombreSuscriptor", vNombreSuscriptor);
        sessionStorage.setItem("Nombre", obtenerSoloNombre(vNombreSuscriptor));
        sessionStorage.setItem(
          "APaterno",
          obtenerSoloApellidoPaterno(vNombreSuscriptor)
        );
        sessionStorage.setItem(
          "AMaterno",
          obtenerSoloApellidoMaterno(vNombreSuscriptor)
        );

        isLoading(false);
        //doConsultaCuenta(p_numerocuenta);
        reloadBarraSuperior(1000);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      isLoading(false);
      reloadBarraSuperior(1000);
    }
  };

  const obtenerSoloNombre = (p_nombrecompleto: string) => {
    var arrayDeCadenas = p_nombrecompleto.split(" ");
    return arrayDeCadenas[0];
  };

  const obtenerSoloApellidoPaterno = (p_nombrecompleto: string) => {
    var arrayDeCadenas = p_nombrecompleto.split(" ");
    return arrayDeCadenas[arrayDeCadenas.length - 2];
  };

  const obtenerSoloApellidoMaterno = (p_nombrecompleto: string) => {
    var arrayDeCadenas = p_nombrecompleto.split(" ");
    return arrayDeCadenas[arrayDeCadenas.length - 1];
  };

  const nuevoNumeroDeCuenta = async (p_etargetvalue: string) => {
    sessionStorage.setItem("cuenta", p_etargetvalue);
    return p_etargetvalue;
  };

  const doConsultaCuenta = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaCuentaRestDO: ConsultaCuentaRest_Entrada =
        builtConsultaCuentaRestInput(p_numerocuenta);
      let par = ConsultaCuentaRest_Parametros(ConsultaCuentaRestDO);
      let ConsultaCuentaRespuesta: ConsultaCuenta_Respuesta = await ConsultaWS(
        par
      );

      if (
        ConsultaCuentaRespuesta.EBMHeaderResponse &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorNegocio.Estado == "ok" &&
        ConsultaCuentaRespuesta.EBMHeaderResponse.ErrorTecnico.code === "ok"
      ) {
        if (
          ConsultaCuentaRespuesta != null &&
          ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .ListOfServiceInstance &&
          ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0]
            .ListOfServiceInstance != null
        ) {
          sessionStorage.setItem(
            "MSISDN",
            validarNulosYIndefinidios(
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance[0].MSISDN
            )
          );
          sessionStorage.setItem(
            "tipoCliente",
            validarNulosYIndefinidios(
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].BillPaymentSystem
            )
          );
          setTipoClienteContext(
            ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
              .Account[0].BillPaymentSystem
          );
          sessionStorage.setItem(
            "accountType",
            validarNulosYIndefinidios(
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].Type
            )
          );
          sessionStorage.setItem(
            "marketclass",
            validarNulosYIndefinidios(
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].MarketClass
            )
          );

          if (
            ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
              .Account[0].BillPaymentSystem === "POS"
          ) {
            let ar1: any =
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance;

            ar1.forEach((item: any) => {
              if (
                item.SlaveHierarchy === "Master" &&
                item.ServiceProductType === "VIDEO"
              ) {
                let ar2: object[] =
                  item.ListOfInstanceComponent.InstanceComponent;

                ar2.forEach((item2: any) => {
                  if (item2.ProductCategory === "Paquete Principal") {
                    sessionStorage.setItem(
                      "Paquete",
                      validarNulosYIndefinidios(item2.Product)
                    );

                    let banderaHD = validarNulosYIndefinidios(item2.Product);
                    let banderaHD2 = validarNulosYIndefinidios(
                      ConsultaCuentaRespuesta.ConsultaCuenta_Salida
                        .ListOfAccount.Account[0].AccountTechnology
                    );

                    if (
                      banderaHD.search("HD") ||
                      banderaHD.search("GOLD") ||
                      banderaHD.search("BLACK") ||
                      banderaHD.search("PLATINUM") ||
                      banderaHD2 === "HD"
                    ) {
                      sessionStorage.setItem("banderaHD", "Y");
                    } else {
                      sessionStorage.setItem("banderaHD", "N");
                    }

                    let fechaInicio = item2.EffectiveStartDate.substring(0, 10);
                    sessionStorage.setItem("fechaInicioRecarga", fechaInicio);
                    let fechaFin = item2.EffectiveEndDate;

                    if (fechaFin !== null) {
                      fechaFin.substring(0, 10);
                      const ar2 = fechaFin.split("-");
                      sessionStorage.setItem(
                        "fechaFinRecarga",
                        ar2[2] + "-" + ar2[1] + "-" + ar2[0]
                      );
                    } else {
                      sessionStorage.setItem("fechaFinRecarga", fechaFin);
                    }
                  }
                });
              }

              sessionStorage.setItem(
                "StreetAddrCalle",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
                )
              );
              sessionStorage.setItem(
                "AddrNumNumExt",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
                )
              );
              sessionStorage.setItem(
                "AddrNumNumInt",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].NumInt
                )
              );
              sessionStorage.setItem(
                "ProvinceColonia",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
                )
              );
              sessionStorage.setItem(
                "PrimaryAccountCountry",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].PrimaryAccountCountry
                )
              );
              sessionStorage.setItem(
                "CountyDelMun",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].CountyDelMun
                )
              );
              sessionStorage.setItem(
                "StateEstado",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StateEstado
                )
              );
              sessionStorage.setItem(
                "PostalCodeCP",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
                )
              );
              let vDireccion =
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
                ) +
                " no. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
                ) +
                " no. interior " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].NumInt
                ) +
                ", Col. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
                ) +
                ", " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].CityPoblacion
                ) +
                ", " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StateEstado
                ) +
                ", C.P. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
                );
              sessionStorage.setItem("direccion", vDireccion);
              sessionStorage.setItem(
                "assetNumber",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfServiceInstance.ServiceInstance[0]
                    .AssetNumber
                )
              );
              sessionStorage.setItem(
                "SecondAssetNumber",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfServiceInstance.ServiceInstance[0]
                    .SecondAssetNumber
                )
              );
            });
          } else {
            //Inicia seccion para prepago
            let ar1: any =
              ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                .Account[0].ListOfServiceInstance.ServiceInstance;

            ar1.forEach((item: any) => {
              if (
                item.SlaveHierarchy === "Master" &&
                item.ServiceProductType === "VIDEO"
              ) {
                let ar2: object[] =
                  item.ListOfInstanceComponent.InstanceComponent;

                ar2.forEach((item2: any) => {
                  if (
                    item2.ProductCategory === "Service" ||
                    item2.ProductCategory === "Paquete Principal"
                  ) {
                    let miPaquete: string = "";
                    if (
                      ConsultaCuentaRespuesta.ConsultaCuenta_Salida
                        .ListOfAccount.Account[0].AccountTechnology === "SD"
                    ) {
                      miPaquete = `${ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTypeRecharge}`;
                    } else {
                      miPaquete = `${ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTypeRecharge} ${ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount.Account[0].AccountTechnology}`;
                    }
                    //sessionStorage.setItem("Paquete",validarNulosYIndefinidios(item2.Product));
                    sessionStorage.setItem(
                      "Paquete",
                      validarNulosYIndefinidios(miPaquete)
                    );
                    let banderaHD = validarNulosYIndefinidios(item2.Product);
                    let banderaHD2 = validarNulosYIndefinidios(
                      ConsultaCuentaRespuesta.ConsultaCuenta_Salida
                        .ListOfAccount.Account[0].AccountTechnology
                    );

                    if (
                      banderaHD.search("HD") ||
                      banderaHD.search("GOLD") ||
                      banderaHD.search("BLACK") ||
                      banderaHD.search("PLATINUM") ||
                      banderaHD2 === "HD"
                    ) {
                      sessionStorage.setItem("banderaHD", "Y");
                    } else {
                      sessionStorage.setItem("banderaHD", "N");
                    }
                  }
                });
              }

              sessionStorage.setItem(
                "Estatus",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].EstatusVeTV
                )
              );
              sessionStorage.setItem(
                "AddrNumNumExt",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
                )
              );
              sessionStorage.setItem(
                "AddrNumNumInt",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].NumInt
                )
              );
              sessionStorage.setItem(
                "ProvinceColonia",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
                )
              );
              sessionStorage.setItem(
                "PrimaryAccountCountry",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].PrimaryAccountCountry
                )
              );
              sessionStorage.setItem(
                "CountyDelMun",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].CountyDelMun
                )
              );
              sessionStorage.setItem(
                "StateEstado",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StateEstado
                )
              );
              sessionStorage.setItem(
                "PostalCodeCP",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
                )
              );
              let vDireccion =
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StreetAddrCalle
                ) +
                " no. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].AddrNumNumExt
                ) +
                " no. interior " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].NumInt
                ) +
                ", Col. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].ProvinceColonia
                ) +
                ", " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].CityPoblacion
                ) +
                ", " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].StateEstado
                ) +
                ", C.P. " +
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].PostalCodeCP
                );
              sessionStorage.setItem("direccion", vDireccion);
              sessionStorage.setItem(
                "CountryPais",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfAddress.AccountAddress[0].CountryPais
                )
              );
              setPais(
                ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                  .Account[0].ListOfAddress.AccountAddress[0].CountryPais
              );
              sessionStorage.setItem(
                "montoPaquete",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfServiceAgreement.ServiceAgreement[0]
                    .SubscriptionAmount
                )
              );
              sessionStorage.setItem(
                "assetNumber",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfServiceInstance.ServiceInstance[0]
                    .AssetNumber
                )
              );
              sessionStorage.setItem(
                "SecondAssetNumber",
                validarNulosYIndefinidios(
                  ConsultaCuentaRespuesta.ConsultaCuenta_Salida.ListOfAccount
                    .Account[0].ListOfServiceInstance.ServiceInstance[0]
                    .SecondAssetNumber
                )
              );
            });
          } //termina seccion de prepago
        }

        doConsultarSaldosCorrientes(p_numerocuenta);
      } else {
        console.error(ConsultaCuentaRespuesta);
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      isLoading(false);
    }
  };

  const validarNulosYIndefinidios = (param: any) => {
    var retorno: string = "";
    if (param != null && typeof param != "undefined") {
      retorno = param;
    } else {
      retorno = "";
    }

    return retorno;
  };

  const doConsultarSaldosCorrientes = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultarSaldosCorrientesDO: ConsultarSaldosCorrientes_Entrada =
        builtConsultarSaldosCorrientesInput(p_numerocuenta);
      let par = ConsultarSaldosCorrientes_Parametros(
        ConsultarSaldosCorrientesDO
      );
      let ConsultarSaldosCorrientesRespuesta: ConsultarSaldosCorrientes_Respuesta =
        await ConsultaWS(par);

      if (
        ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse &&
        ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        ConsultarSaldosCorrientesRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok"
      ) {
        if (
          ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
            .FechaPagoOportuno !== null
        ) {
          sessionStorage.setItem(
            "saldo",
            ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO
              .SaldoTotalPagoOportuno
          );

          let cadena =
            ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.FechaPagoOportuno.substring(
              0,
              10
            );
          const ar = cadena.split("-");
          sessionStorage.setItem("fechaFin", ar[2] + "-" + ar[1] + "-" + ar[0]);
        } else {
          let saldoFormato: number = Number.parseFloat(
            ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotal
          );

          sessionStorage.setItem(
            "saldo",
            ConsultarSaldosCorrientesRespuesta.SaldosCorrientesEBO.SaldoTotal
          );
          let cadena =
            ConsultarSaldosCorrientesRespuesta.SaldosPorFacturarEBO.FechaProximoCorte.substring(
              0,
              10
            );
          const ar = cadena.split("-");
          sessionStorage.setItem("fechaFin", ar[2] + "-" + ar[1] + "-" + ar[0]);
        }
        doConsultarServiciosCuenta(p_numerocuenta);
      } else {
        console.error(ConsultarSaldosCorrientesRespuesta);
        isLoading(false);
      }

      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      isLoading(false);
    }
  };

  const doConsultarServiciosCuenta = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultarServiciosCuentaDO: ConsultarServiciosCuenta_Entrada =
      builtInputVarConsultarServiciosCuentaInput(
        `${
          flujo === "Sky+"
            ? sessionStorage.getItem("cuenta")!
            : sessionStorage.getItem("cuenta")!
        }`
      );
      let par = ConsultarServiciosCuenta_Parametros(ConsultarServiciosCuentaDO);
      let ConsultarServiciosCuentaRespuesta: ConsultarServiciosCuenta_Respuesta =
        await ConsultaWS(par);

      if (
        ConsultarServiciosCuentaRespuesta.EBMHeaderResponse &&
        ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        ConsultarServiciosCuentaRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok"
      ) {
        sessionStorage.setItem(
          "pais",
          validarNulosYIndefinidios(
            ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Pais
          )
        );
        setPais(ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Pais);
        sessionStorage.setItem(
          "diferenciaGMT",
          validarNulosYIndefinidios(
            ConsultarServiciosCuentaRespuesta.CuentaSelEBO.DiferenciaHoraria
          )
        );
        sessionStorage.setItem(
          "rowId",
          validarNulosYIndefinidios(
            ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId
          )
        );
        sessionStorage.setItem(
          "RowIdContacto",
          validarNulosYIndefinidios(
            ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowIdContacto
          )
        );
        sessionStorage.setItem(
          "BanderaNoOPPV",
          validarNulosYIndefinidios(
            ConsultarServiciosCuentaRespuesta.CuentaSelEBO
          )
        );
        sessionStorage.setItem(
          "servicios",
          JSON.stringify(ConsultarServiciosCuentaRespuesta.ListServicios)
        );
        sessionStorage.setItem("btiFlag", "0");
        validateBTI(
          ConsultarServiciosCuentaRespuesta.ListServicios.ServicioEBO
        );

        let date = new Date();
        let cadena = date.toLocaleString();
        let cadenas = cadena.split(",");
        let fechas = cadenas[0].split("/");
        let hora = cadenas[1].split(":");
        sessionStorage.setItem(
          "idSesion",
          fechas[2] +
            fechas[0] +
            fechas[1] +
            hora[0].trimStart() +
            hora[1] +
            hora[2].slice(0, 2) +
            sessionStorage.getItem("cuenta")
        );
        sessionStorage.setItem(
          "organizacion",
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.Organizacion
        );
        doConsultarIRD(
          ConsultarServiciosCuentaRespuesta.CuentaSelEBO.RowId,
          p_numerocuenta
        );
      } else {
        console.error(ConsultarServiciosCuentaRespuesta);
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      isLoading(false);
    }
  };

  const getAccountDetails = async (cuenta: string) => {
    const accountDetailsDO: AccountDetails_Entrada = { userId: cuenta };
    let accountDetailsParametros = AccountDetails_Parametros(accountDetailsDO);

    let accountDetailsRespuesta: AccountDetails_Respuesta = await ConsultaWS(
      accountDetailsParametros
    );

    if (
      accountDetailsRespuesta.errormessage === "Ok" &&
      accountDetailsRespuesta.errorno == 0
    ) {
      sessionStorage.setItem(
        "cuenta",
        accountDetailsRespuesta.Account.Account.AccountNumber
      );

      let date = new Date();
      let cadena = date.toLocaleString();
      let cadenas = cadena.split(",");
      let fechas = cadenas[0].split("/");
      let hora = cadenas[1].split(":");
      sessionStorage.setItem(
        "idSesion",
        fechas[2] +
          fechas[0] +
          fechas[1] +
          hora[0].trimStart() +
          hora[1] +
          hora[2].slice(0, 2) +
          accountDetailsRespuesta.Account.Account.AccountNumber
      );

      sessionStorage.setItem(
        "EmailNotif",
        accountDetailsRespuesta.Account.Contact.Email
      );
      sessionStorage.setItem(
        "TelCasa",
        accountDetailsRespuesta.Account.Contact.Phone
      );

      sessionStorage.setItem(
        "TelCasa",
        accountDetailsRespuesta.Account.Contact.Phone
      );

      sessionStorage.setItem(
        "Nombre",
        accountDetailsRespuesta.Account.Contact.FirstName
      );
      sessionStorage.setItem(
        "APaterno",
        accountDetailsRespuesta.Account.Contact.MiddleName
      );
      sessionStorage.setItem(
        "AMaterno",
        accountDetailsRespuesta.Account.Contact.LastName
      );

      sessionStorage.setItem(
        "StreetAddrCalle",
        accountDetailsRespuesta.Account.Account.Billing.Street
      );
      sessionStorage.setItem(
        "AddrNumNumExt",
        accountDetailsRespuesta.Account.Account.Billing.StreetNumber
      );
      sessionStorage.setItem(
        "ProvinceColonia",
        accountDetailsRespuesta.Account.Account.Billing.District
      );
      sessionStorage.setItem(
        "PrimaryAccountCountry",
        accountDetailsRespuesta.Account.Account.Billing.Country
      );
      if (banderaPais === false) {
        setPais("MEX");
      }
      sessionStorage.setItem(
        "CountyDelMun",
        accountDetailsRespuesta.Account.Account.Billing.Delegation
      );
      sessionStorage.setItem(
        "StateEstado",
        accountDetailsRespuesta.Account.Account.Billing.State
      );
      sessionStorage.setItem(
        "PostalCodeCP",
        accountDetailsRespuesta.Account.Account.Billing.PostalCode
      );
    }
  };

  const validateBTI = (ServicioEBO: ServicioEBO[]) => {
    for (let i = 0; i < ServicioEBO.length; i++) {
      if (
        ServicioEBO[i].ServiceProductType.toLowerCase().includes("datos") ||
        ServicioEBO[i].ServiceProductType.toLowerCase().includes("CELULAR")
      ) {
        sessionStorage.setItem("btiFlag", "1");
        break;
      }
    }
  };

  const doConsultarIRD = async (p_rowid: string, p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultarIRDDO: ConsultarIRD_Entrada = { RowID: `${p_rowid}` };
      let ConsultarIRDPar = ConsultarIRD_Parametros(ConsultarIRDDO);

      let ConsultarIRDRespuesta: ConsultarIRD_Respuesta = await ConsultaWS(
        ConsultarIRDPar
      );

      if (
        ConsultarIRDRespuesta.Tarjeta &&
        ConsultarIRDRespuesta.Tarjeta.length > 0
      ) {
        sessionStorage.setItem(
          "tarjetas",
          JSON.stringify(ConsultarIRDRespuesta.Tarjeta)
        );
        obtenerTIMaster(ConsultarIRDRespuesta.Tarjeta, p_numerocuenta);
      } else {
        console.error(ConsultarIRDRespuesta);
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error(error);
      isLoading(false);
    }
  };

  const obtenerTIMaster = (p_Tarjeta: Tarjeta[], p_numerocuenta: string) => {
    for (let index = 0; index < p_Tarjeta.length; index++) {
      if (p_Tarjeta[index].Jerarquia === "Master") {
        sessionStorage.setItem(
          "tarjetaMaster",
          JSON.stringify(p_Tarjeta[index])
        );
        break;
      }
    }
    doConsultarCuentaAsociada(p_numerocuenta);
  };

  const doConsultarCuentaAsociada = async (p_numerocuenta: string) => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------

      const ConsultarCuentaAsociadaEntrada: ConsultarCuentaAsociada_Entrada =
        builtConsultarCuentaAsociada_Entrada(p_numerocuenta);
      let ConsultarCuentaAsociadaParametros =
        ConsultarCuentaAsociada_Parametros(ConsultarCuentaAsociadaEntrada);

      let ConsultarCuentaAsociadaRespuesta: ConsultarCuentaAsociada_Respuesta =
        await ConsultaWS(ConsultarCuentaAsociadaParametros);

      if (
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta &&
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta.length > 0 &&
        ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta != null
      ) {
        sessionStorage.setItem(
          "esCuentaCorporativaArray",
          JSON.stringify(ConsultarCuentaAsociadaRespuesta.ListaCuentas.Cuenta)
        );
        isLoading(false);
        reloadBarraSuperior(1000);
      } else {
        console.error("No hay cuentas Hijas recuperadas");
        sessionStorage.setItem("esCuentaCorporativaArray", JSON.stringify([]));
        isLoading(false);
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      console.error("No hay cuentas Hijas recuperadas", error);
      sessionStorage.setItem("esCuentaCorporativaArray", JSON.stringify([]));
      isLoading(false);
    }
  };

  const reloadBarraSuperior = (p_miliseconds: number) => {
    setTimeout(() => {
      window.location.reload();
    }, p_miliseconds);
  };

  return (
    <>
      <Loading isLoading={loading} />

      <Container fluid className={styles.container + " "}>
        <Row>
          <Col>
            <Image src={skyLogo} rounded className={styles.logo} />
          </Col>
          <Col className={styles.buttonCol}>
            <div
              id="bigSuperiorBar"
              className={"d-none d-sm-block d-md-block d-lg-block d-xl-block"}
            >
              <Col className={styles.buttonCol}>
                {showList && cuentasHijas.length > 0 && cuentasHijas != null ? (
                  <Row>
                    <Form.Select
                      value={sessionStorage.getItem("cuenta")!}
                      onChange={obtieneCuentaHijaSeleccionada}
                    >
                      {cuentasHijas.map(
                        (cuentaHijas: Cuenta, index: number) => {
                          return (
                            <option key={index} value={cuentaHijas.CuentaSKY}>
                              {cuentaHijas.CuentaSKY}
                            </option>
                          );
                        }
                      )}
                    </Form.Select>
                  </Row>
                ) : sessionStorage.getItem("esCuentaCorporativa") === "V" ? (
                  <Row>
                    <Form.Select>
                      <option key={"0"} value={"NA"}>
                        {"No hay Cuentas para  mostrar"}
                      </option>
                    </Form.Select>
                  </Row>
                ) : (
                  <></>
                )}

                <Row>
                  {" "}
                  <Button onClick={doLogout} className={styles.button}>
                    Cerrar Sesión
                  </Button>
                </Row>
              </Col>
            </div>
            <div
              id="smallSuperiorBarButton"
              className={"d-sm-none d-md-none d-lg-none d-xl-none"}
            >
              <GiHamburgerMenu
                id="menuIcon"
                size={30}
                className={styles["menuButton"]}
                onClick={handleShow}
              />
              <CgClose
                id="closeIcon"
                size={30}
                className={styles["closeButton"]}
                onClick={handleClose}
              />
            </div>
          </Col>
        </Row>
        <Row className={styles.spectrumLine}>
          <Col>
            <div
              id="smallSuperiorBarMenu"
              className={
                "d-sm-none d-md-none d-lg-none d-xl-none " +
                styles["smallSuperiorBarMenu"]
              }
            >
              <ProSidebarProvider>
                <BarraMenu />
              </ProSidebarProvider>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
